import React, { Component } from "react";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import App from "./App";
import GetRoutes from "../routes";

export default class Root extends Component {
  componentDidMount() {
    this.unlisten = this.props.history.listen(this.handleLocationChange);
    this.handleLocationChange(this.props.history.location);
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  handleLocationChange = (location) => {
    const badge = document.querySelector(".grecaptcha-badge");
    if (!badge) return;

    if (location.pathname === "/signin") {
      badge.style.display = "block";
    } else {
      badge.style.display = "none";
    }
  };

  render() {
    const { store, history } = this.props;
    return (
      <Provider store={store}>
        <ConnectedRouter
          history={history}
          onUpdate={() => window.scrollTo(0, 0)}
        >
          <App>
            <GetRoutes />
          </App>
        </ConnectedRouter>
      </Provider>
    );
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
};
